import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  providerCustomerPortalMenuService,
  ProviderCustomerPortalMenuRequestError,
} from '@/services/provider/customer-portal-menu.service';
import type {
  CustomerPortalMenuSettings,
  UpdateCustomerPortalMenuInput,
} from '@/types/customer-portal-menu';

export const providerCustomerPortalMenuKeys = {
  all: ['provider', 'customer-portal-menu'] as const,
  detail: () => [...providerCustomerPortalMenuKeys.all, 'detail'] as const,
};

export function useProviderCustomerPortalMenuSettings(enabled = true) {
  return useQuery<CustomerPortalMenuSettings, ProviderCustomerPortalMenuRequestError>({
    queryKey: providerCustomerPortalMenuKeys.detail(),
    queryFn: () => providerCustomerPortalMenuService.getSettings(),
    enabled,
  });
}

export function useUpdateProviderCustomerPortalMenuSettings() {
  const queryClient = useQueryClient();

  return useMutation<
    CustomerPortalMenuSettings,
    ProviderCustomerPortalMenuRequestError,
    UpdateCustomerPortalMenuInput
  >({
    mutationFn: (input) => providerCustomerPortalMenuService.updateSettings(input),
    onSuccess: (settings) => {
      queryClient.setQueryData(providerCustomerPortalMenuKeys.detail(), settings);
    },
  });
}
